import { Capacitor } from '@capacitor/core';

export function isNativeMobile(): boolean {
  return Capacitor.isNativePlatform()
    && ['android', 'ios'].includes(Capacitor.getPlatform());
}

export type NativeNetworkProvider = 'starlink' | 'other' | 'unknown';

let latestNetworkProvider: NativeNetworkProvider = 'unknown';
const providerListeners = new Set<(provider: NativeNetworkProvider) => void>();

export function recordNativeNetworkProvider(provider: NativeNetworkProvider): void {
  latestNetworkProvider = provider;
  for (const listener of providerListeners) listener(provider);
}

export function currentNativeNetworkProvider(): NativeNetworkProvider {
  return latestNetworkProvider;
}

export function subscribeNativeNetworkProvider(
  listener: (provider: NativeNetworkProvider) => void,
): () => void {
  providerListeners.add(listener);
  return () => providerListeners.delete(listener);
}
